export default __webpack_public_path__ + "static/ian olano-063ca2199bc14e8c99024a037c7922c6.png";